import { Form, Modal } from "antd";
import React from "react";
import { CreateWasteAccumulationSiteDto } from "../../../api";
import { wasteAccumulationSitesColumns } from "../form/columns";

interface WasteAccumulationSiteFormProps {
  visible: boolean;
  setVisible: Function;
  onCreateWasteAccumulationSite: (values: CreateWasteAccumulationSiteDto) => void;
}

export const WasteAccumulationSiteForm: React.FC<WasteAccumulationSiteFormProps> = ({ visible, setVisible, onCreateWasteAccumulationSite }) => {
  const [form] = Form.useForm<CreateWasteAccumulationSiteDto>();

  return (
    <Modal open={visible} onOk={form.submit} okText="Создать" cancelText="Отмена" onCancel={() => setVisible(false)}>
      <Form form={form} className="p-8" layout="vertical" onFinish={onCreateWasteAccumulationSite}>
        {wasteAccumulationSitesColumns.map(({ title, dataIndex, rules, inputNode }, index) => (
          <Form.Item label={title} name={dataIndex} rules={rules} key={index}>
            {inputNode}
          </Form.Item>
        ))}
      </Form>
    </Modal>
  );
};
